import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  public ordersUrl = 'https://arike.malonglobaltech.com/api/user/orders'
  public cartsUrl = 'https://arike.malonglobaltech.com/api/user/cart'
  public addToCartUrl = 'https://arike.malonglobaltech.com/api/user/cart/add'
  public removeItemsFromCartUrl = 'https://arike.malonglobaltech.com/api/user/cart/add'
  public shippingUrl = 'https://arike.malonglobaltech.com/api/user/shipping/fees'

  constructor(
    public http: HttpClient 
  ) { }

  async addToCart(obj){
      const token = await JSON.parse(localStorage.getItem('token'))
      return await this.http.post(this.addToCartUrl, obj, {
        headers: new HttpHeaders({        
            'Content-Type':  'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
          })
      }) 
  }

  async addToMyCart(obj, token){
    console.log(obj, token)
    return await this.http.post(this.addToCartUrl, obj, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
          })
      }) 
  }

  async deleteCart(){
    const token = await JSON.parse(localStorage.getItem('token'))
    return await this.http.delete(this.removeItemsFromCartUrl, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }

  async getItemsFromCart(){
    const token = await JSON.parse(localStorage.getItem('token'))
    return await this.http.get(this.cartsUrl, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }
  
  async createOrder(obj){
    const token = await JSON.parse(localStorage.getItem('token'))
    return await this.http.post(this.ordersUrl, obj, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }

  async getShippingFees(){
    const token = await JSON.parse(localStorage.getItem('token'))
    return await this.http.get(this.shippingUrl, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }

  // async addToCart(uid, product, selected_size, qty){
  //     const cid = await this.afs.createId();
  //     this.afs.collection('carts').doc(cid).set({
  //       id: cid,
  //       product: product,
  //       size: selected_size,
  //       date: new Date().getTime(),
  //       quantity: qty,
  //       userId: uid,
  //       color: 'none'
  //     })
  // }

  // async getCart(uid){
  //   return this.afs.collection('carts', ref=> ref.where('userId', '==', uid))
  // }

  // async deleteCart(id){
  //   this.afs.collection('carts').doc(id).delete()
  // }

  // updateCart(id, quantity){
  //   this.afs.collection('carts').doc(id).update({
  //     quantity: quantity
  //   })
  // }

  // async checkOut(first_name, last_name, phone, email, zip_code, country, state, address1, address2, carts, ref, uid, totalPrice, totalQuanity){
  //   const id = await this.afs.createId()
  //   await this.afs.collection('orders').doc(id).set({
  //     first_name, last_name, phone, email, zip_code, country, state, address1, address2, carts, ref, userId: uid,  totalPrice: totalPrice, totalQuanity: totalQuanity,
  //     status: 'pending', date: new Date().getTime(), id: id
  //   })
  // }


  // async clearCarts(uid){
  //   this.getCart(uid).then(resp=>{
  //     resp.get()
  //     .subscribe((snapshot) => {
  //       // When there are no documents left, we are done
  //       if (snapshot.size == 0) {
  //         return 0;
  //       }
  
  //       // Delete documents in a batch
  //       let batch = this.afs.firestore.batch();
  //       snapshot.docs.forEach((doc) => {
  //         batch.delete(doc.ref);
  //       });
  
  //       return batch.commit().then(() => {
  //         return snapshot.size;
  //       });
  //     })
  //   })
  // }


}
